/* ==========================================================================
   PDP Redesign – Mobiler Info-Tab-Slider + Sektions-Relocation
   Ergänzt pdp.js. 1) Tab-Slider: Tab-Tap scrollt Panel, Panel-Swipe aktiviert
   Tab (synchron); der aktive Tab wird in die Tab-Leiste gescrollt (4 Tabs).
   2) Verschiebt die Tech-Details-Sektion mobil direkt unter die Buy-Box; auf
   Desktop wird die Originalposition wiederhergestellt.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- Tab-Slider ---------- */
  function initTabs(scope) {
    (scope || document).querySelectorAll('[data-pdp-tabs]').forEach(function (root) {
      if (root.dataset.pdpTabsInit) return;
      root.dataset.pdpTabsInit = '1';

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-tab]'));
      var bar = root.querySelector('.pdp-tabbar');
      var panels = root.querySelector('[data-pdp-tab-panels]');
      if (!tabs.length || !panels) return;

      function setActive(idx) {
        tabs.forEach(function (t, i) {
          var on = i === idx;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        var active = tabs[idx];
        if (active && bar && bar.scrollWidth > bar.clientWidth) {
          var target = active.offsetLeft - (bar.clientWidth - active.offsetWidth) / 2;
          bar.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
        }
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          setActive(i);
          panels.scrollTo({ left: i * panels.clientWidth, behavior: 'smooth' });
        });
      });

      var raf = null;
      panels.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          if (!panels.clientWidth) return;
          var idx = Math.round(panels.scrollLeft / panels.clientWidth);
          if (idx < 0) idx = 0;
          if (idx > tabs.length - 1) idx = tabs.length - 1;
          setActive(idx);
        });
      }, { passive: true });

      setActive(0);
    });
  }

  /* ---------- Mobile Relocation: Tech-Details unter die Buy-Box ---------- */
  function initRelocate() {
    var tech = document.querySelector('[data-pdp-tech-section]');
    var techSection = tech ? tech.closest('.shopify-section') : null;
    var main = document.querySelector('[data-pdp-main]');
    var mainSection = main ? main.closest('.shopify-section') : null;
    if (!techSection || !mainSection || techSection.dataset.pdpReloc) return;
    techSection.dataset.pdpReloc = '1';

    var home = document.createComment('pdp-tech-home');
    techSection.parentNode.insertBefore(home, techSection);

    var mq = window.matchMedia('(max-width: 740px)');
    function apply() {
      if (mq.matches) {
        if (mainSection.nextSibling !== techSection) {
          mainSection.parentNode.insertBefore(techSection, mainSection.nextSibling);
        }
      } else {
        if (home.nextSibling !== techSection) {
          home.parentNode.insertBefore(techSection, home.nextSibling);
        }
      }
    }
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
  }

  function boot() {
    initTabs(document);
    initRelocate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
